// import { useEffect, useState } from "react"
// import { Link, useLocation, useParams } from "react-router-dom"
// import { GetAccess } from "../../../Components/Utils/roles"
// import Breadcrumb from "../../../Components/Utils/Breadcrumb"
// import SearchBar from "../../../Components/Utils/SearchBar"
// import { CreateButton, FilterButton, ImportButton } from "../../../Components/Utils/Buttons"

import { useEffect, useState } from "react"
import { Link, useLocation, useParams } from "react-router-dom"
import { GetAccess } from "../../../../../Components/Utils/roles"
import Breadcrumb from "../../../../../Components/Utils/Breadcrumb"
import SearchBar from "../../../../../Components/Utils/SearchBar"
import { ClearFilterButton, CreateButton, FilterButton, ImportButton } from "../../../../../Components/Utils/Buttons"

const StoreSubLayout = (
    {
        getData=() => {},
        setSearchQuery=()=>{},
        CreateAccess= false,
        ImportAccess= false,
        setOpen=()=>{},
        children,
        onCreateClick,
        searchFun=()=>{},
        isFilter=false,
        setFilterOpen=()=>{},
        ClearFilter=()=>{},
        searchValue="",



    }
) =>{
    let {pathname} = useLocation()
    let {officeId,projeCtId} = useParams()
    
    const [module,setModule] = useState("")
    
    useEffect(() =>{
        if(pathname == `/project/store/grn/${officeId}/${projeCtId}`){
            setModule("GRN")
        }else if(pathname == `/project/store/inventory/${officeId}/${projeCtId}`){
            setModule("Inventory")
        }else if(pathname == `/project/store/assets/${officeId}/${projeCtId}`){
            setModule("Asset")
        }else if(pathname == `/project/store/delevery-notes/${officeId}/${projeCtId}`){
            setModule("Delivery Note")
        }else if(pathname == `/project/store/packing-list/${officeId}/${projeCtId}`){
            setModule("Packing List")
        }else if(pathname == `/project/store/returns/${officeId}/${projeCtId}`){
            setModule("Return")
        }else if(pathname == `/project/store/request/${officeId}/${projeCtId}`){
            setModule("Request")
        }else if(pathname == `/project/store/shipment-status/${officeId}/${projeCtId}`){
            setModule("Shipment Status")
        }
    },[pathname])
    console.log(module,"module");
    

    let LinkItem = [
        {
            label:"Shipment Status",
            link:`/project/store/shipment-status/${officeId}/${projeCtId}`,
            access:GetAccess(),
        },
        {
            label:"GRN",
            link:`/project/store/grn/${officeId}/${projeCtId}`,
            access:GetAccess(),
        },
        {
            label:"Inventory",
            link:`/project/store/inventory/${officeId}/${projeCtId}`,
            access:true,
        },
        {
            label:"Asset",
            link:`/project/store/assets/${officeId}/${projeCtId}`,
            access:GetAccess(),
        },
        {
            label:"Return",
            link:`/project/store/returns/${officeId}/${projeCtId}`,
            access:GetAccess(),
        },
        {
            label:"Request",
            link:`/project/store/request/${officeId}/${projeCtId}`,
            access:GetAccess(),
        },
       
        {
            label:"Delivery Note",
            link:`/project/store/delevery-notes/${officeId}/${projeCtId}`,
            access:true,
        },
       
        // {
        //     label:"Packing List",
        //     link:`/project/store/packing-list/${officeId}/${projeCtId}`,
        //     access:GetAccess(),
        // },
      
       
        
    ]
    
    return(
        <div className=" w-full  h-full py-2 px-4 overflow-hidden">
            <div className="">
            <div className="md:flex justify-between w-full ">
            {/* <Breadcrumb items={[
               
                {
                    name:"Store"
                },
                { name: `${module}` },

            ]} /> */}
<div className=" w-full  flex items-center gap-x-1 ">
            {
                LinkItem && LinkItem.map((item, i) => {
                    return(
                        <>
                         {
                            item.access && (
                                                    <Link to={item?.link} className={`mx-3 pb-1 text-xs 2xl:text-sm font-medium text-baseColor-primary ${item?.link == pathname ?"border-b-2 border-baseColor-primary":"border-b-2 border-transparent"}   `}  key={item?.link} >{item?.label||""}</Link>
                                     )
                         }
                        </>
                    )
                })
            }
        </div>
            

            <div className=" flex justify-end items-center gap-3 ">
            <form className="flex items-center gap-3 mx-0" onSubmit={getData}>
            <SearchBar handleChange={searchFun}  value={searchValue}/>
            </form>
              <FilterButton label='Filter'  handleClick={()=>{setFilterOpen(true);setSearchQuery("");}} />
              {isFilter&& <ClearFilterButton label='Clear'  handleClick={ClearFilter} />} 
               {ImportAccess && <ImportButton label="Import" handleClick={()=>setOpen(true)}    />}

              {CreateAccess && <Link to={`${pathname}/create`}><CreateButton label={module}/></Link>}
                  {/* <BackButton/> */}
                </div>
            </div>
           
            
           
            <div className=" w-full h-[calc(100vh-140px)]  ">
               {children} 
            </div>
            </div>
        </div>
    )
}


export default StoreSubLayout;